var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var BrandApi_1;
import { harriApi, HarriAPI } from "@core/apis/HarriAPI";
import { BonusSettingsModel } from "@core/models/brands/bonus-settings.model";
import { hSerializer } from "@core/serializer/h-serializer";
import { BrandsTreeModel } from "@core/models/brands/brands-tree.model";
import { OverTimeSettingsModel } from "@core/models/brands/over-time-settings.model";
import { BrandModel } from "@core/models/brands/brand.model";
import { BrandJobTemplatesModel } from "@core/models/jobs/job-template.model";
import { BrandJobTitlesModel } from "@core/models/team-live/job-titles/brand-job-titles.model";
let BrandApi = class BrandApi extends HarriAPI {
    static { BrandApi_1 = this; }
    static { this.userBrandsListCache = {}; }
    static async getBonusSettings(brandId) {
        let response = await BrandApi_1.request(`brands/${brandId}/settings/bonus`, "GET");
        let jsonConvert = new hSerializer();
        let BonusSettings = jsonConvert.deserializeObject((response.data.data), BonusSettingsModel);
        return BonusSettings;
    }
    ;
    static async getBrandsTree(brandId, includeJobs, includeParent, includeArchivedLocations, filterByServices) {
        let payload = {
            include_jobs: !!includeJobs,
            include_parent: !!includeParent,
            include_archived: !!includeArchivedLocations,
        };
        if (filterByServices) {
            payload.filter_by_services = filterByServices;
        }
        let response = await BrandApi_1.request(`brands/${brandId}/tree`, "GET", payload);
        let jsonConvert = new hSerializer();
        if (response.data.data && !response.data.data.access_type && response.data.data.brands) {
            response.data.data = response.data.data.brands[0];
        }
        let brandTree = jsonConvert.deserializeObject((response.data.data), BrandsTreeModel);
        return brandTree;
    }
    static async getUKBrandPayTypesOvertimeSettings(brandId) {
        let response = await BrandApi_1.request(`brands/${brandId}/settings/pay_types/overtime`, "GET");
        let jsonConvert = new hSerializer();
        let OverTimeSettings = jsonConvert.deserializeObject((response.data.data), OverTimeSettingsModel);
        return OverTimeSettings;
    }
    static async userBrandsByGroupId(groupId, includeServices, includePermissions) {
        let endPoint = environmentsConfig.getEnv().host == "teamcloud" /* APP_HOST.TEAM_SCHEDULE */ ? "APIServers" /* ENDPOINT.CORE */ : "coreReaderAPIServers" /* ENDPOINT.CORE_READER */;
        let apiEndpoint = environmentsConfig.get(endPoint);
        let url = apiEndpoint + 'groups/' + groupId + '/brands';
        if (includeServices && !includePermissions) {
            url += '?include_services=true';
        }
        if (includePermissions && !includeServices) {
            url += '?include_permissions=true';
        }
        if (includeServices && includePermissions) {
            url += '?include_services=true&include_permissions=true';
        }
        if (this.userBrandsListCache[groupId] && Array.isArray(this.userBrandsListCache[groupId])) {
            return JSON.parse(JSON.stringify(this.userBrandsListCache[groupId]));
        }
        else {
            let res = await BrandApi_1.request(url, "GET");
            let serializer = new hSerializer();
            let result = serializer.deserializeArray(res.data.data, BrandModel);
            this.userBrandsListCache[groupId] = result;
            return this.userBrandsListCache[groupId];
        }
    }
    static async getBrandBasicInfo(brandId, includeLocations) {
        const params = { include_locations: !!includeLocations };
        const response = await BrandApi_1.request(`brands/${brandId}/basic_info`, 'GET', params);
        return response.data.data;
    }
    ;
    static async getBrandJobTemplates(brandId, excludeParentTemplates, includeInactivePositions, params, includeChildren) {
        if (!brandId) {
            throw 'This API required a brand id';
        }
        var payLoad = {};
        payLoad.exclude_parent_templates = !!excludeParentTemplates;
        payLoad.include_inactive_positions = !!includeInactivePositions;
        payLoad.post_type = params.post_type;
        payLoad.include_children = !!includeChildren;
        let res = await BrandApi_1.request(`brands/${brandId}/jobs/templates`, "GET", payLoad);
        if (res && res.status === 200 && res.data) {
            if (res.data.status_code === 200) {
                let serializer = new hSerializer();
                let result = serializer.deserializeObject(res.data.data, BrandJobTemplatesModel);
                return result;
            }
            else {
                return {
                    error: 'NOT_AUTHORIZED',
                    status: 403
                };
            }
        }
        else {
            throw res;
        }
    }
    ;
    static async getBrandLocations(brandId) {
        if (!brandId) {
            throw 'This API required a brand id';
        }
        let response = await BrandApi_1.request(`brand/location/${brandId}`, "GET");
        return response.data.data;
    }
    static async getBrandRestrictedEmailDomains(brandId) {
        if (!brandId) {
            throw 'This API required a brand id';
        }
        let response = await BrandApi_1.request(`brands/${brandId}/restricted_email_domains`, "GET");
        return response.data.data;
    }
    static async getBrandCostCenters(brandId) {
        let response = await BrandApi_1.request(`brands/${brandId}/cost_centers`, 'GET');
        return response.data.data.cost_centers;
    }
    static async getBrandRevenueCenters(brandId) {
        let response = await BrandApi_1.request(`brands/${brandId}/revenue_centers`, 'GET');
        if (response.data && response.data.data && response.data.data.revenue_centers && response.data.status_code == 200) {
            return response.data.data.revenue_centers;
        }
        throw (response.error);
    }
    static async getBrandMFASettings(brandId) {
        let response = await BrandApi_1.request(`brands/${brandId}/mfa_authentication/settings`, 'GET');
        return response.data.data;
    }
    static async updateBrandMFASettings(brandId, params) {
        let response = await BrandApi_1.request(`brands/${brandId}/mfa_authentication/settings`, 'PUT', params);
        if (response.data.status_code !== 200) {
            throw (response.data.data);
        }
        return response.data.data;
    }
    static async mediaSettings(brandId, params) {
        if (!brandId) {
            throw "Brand id is required ";
        }
        let response = await BrandApi_1.request('brands/' + brandId + '/media_settings', 'PUT', params);
        if (response.data.status_code != 200) {
            throw (response.error);
        }
        return response.data.data;
    }
    static async getMediaSettings(brandId) {
        let response = await BrandApi_1.request('brands/' + brandId + '/media_settings', 'GET');
        if (response.data.status_code != 200) {
            throw (response.error);
        }
        return response.data.data;
    }
    static async getBusinessBrandsJobTitles(businessId) {
        let response = await BrandApi_1.request(`employees/brands/${businessId}/job_titles`, "GET");
        if (!response.data || response.data.status_code !== 200) {
            throw (response.error);
        }
        let jsonConvert = new hSerializer();
        let businessBrandsJobTitles = jsonConvert.deserializeArray((response.data.data.job_titles || []), BrandJobTitlesModel);
        return businessBrandsJobTitles;
    }
    static async getBrandJobTitles(brandId) {
        let response = await BrandApi_1.request(`brands/${brandId}/job_titles`, "GET");
        let jsonConvert = new hSerializer();
        let brandJobTitles = jsonConvert.deserializeArray(response.data.data.job_titles || [], BrandJobTitlesModel);
        return brandJobTitles;
    }
    static async getBrandsUnderGP(brandId, payload) {
        if (!brandId) {
            throw 'This API required a brand id';
        }
        let response = await BrandApi_1.request(`brands/${brandId}/brands`, 'GET', payload);
        return response.data.data;
    }
    ;
    static { this.getEntryBrandSettings = cacheService.cache(async (brandId) => {
        if (!brandId) {
            throw 'This API required a brand id';
        }
        let apiEndpoint = environmentsConfig.get("coreReaderAPIServers" /* ENDPOINT.CORE_READER */);
        let url = `${apiEndpoint}teamlive/brands/${brandId}/settings`;
        let response = await BrandApi_1.request(url, 'GET');
        return response.data.data;
    })[0]; }
    static async get365RestaurantLocations(brandId) {
        if (!brandId) {
            throw 'This API required a brand id';
        }
        let apiEndpoint = environmentsConfig.get("coreReaderAPIServers" /* ENDPOINT.CORE_READER */);
        let url = `${apiEndpoint}teamlive/brands/${brandId}/settings/restaurant_365/locations`;
        let response = await BrandApi_1.request(url, 'GET');
        return response.data.data;
    }
    ;
    static async getEmployeeBusinessSettings(brandId) {
        if (!brandId) {
            throw 'This API required a brand id';
        }
        let apiEndpoint = environmentsConfig.get("coreReaderAPIServers" /* ENDPOINT.CORE_READER */);
        let url = `${apiEndpoint}teamlive/employees/brands/${brandId}/settings`;
        let response = await BrandApi_1.request(url, 'GET');
        if (!response.data) {
            throw response;
        }
        return response.data.data;
    }
    ;
    static async getBrandGeneralSettings(brandId) {
        if (!brandId) {
            throw 'This API required a brand id';
        }
        let url = `brands/${brandId}/general_settings`;
        let response = await BrandApi_1.request(url, 'GET');
        return response.data.data;
    }
    ;
    static async getUserBrandsTree(asTree, isTeamBrands) {
        let params = {
            view_mode: asTree ? 'STRUCTURED' : 'FLAT',
        };
        if (isTeamBrands) {
            params.filter_services = 'TEAM_SCHEDULING';
        }
        let response = await BrandApi_1.request(`users/brands`, "GET", params);
        return response.data.data.brands;
    }
    ;
    static async searchBrands(brandId, payload) {
        let response = await BrandApi_1.request(`brands/${brandId}/brands/search`, "POST", payload);
        return response.data.data;
    }
    static async starBrand(brandId) {
        let response = await BrandApi_1.request(`brands/${brandId}//employers/favourites`, "POST");
        return response;
    }
    ;
    static async unstarBrand(brandId) {
        let response = await BrandApi_1.request(`brands/${brandId}//employers/favourites`, "DELETE");
        return response;
    }
    ;
    static async getUserJobApplications(params) {
        let apiEndpoint = environmentsConfig.get("coreReaderAPIServers" /* ENDPOINT.CORE_READER */);
        let v2Url = apiEndpoint.replace('v1', 'v2');
        let response = await BrandApi_1.request(v2Url + `users/jobs/applications`, 'GET', params);
        return response.data.data;
    }
    ;
    static async getBrandMainJobsSettings(brandId, jobId) {
        let response = {};
        let jobsSettingsUrl = `brands/${brandId}/jobs/settings`;
        let res = await BrandApi_1.request(jobsSettingsUrl, 'GET');
        if (res?.data?.status_code !== 200) {
            throw (res.data);
        }
        response['logjam_settings'] = res?.data?.data?.logjam_settings || {};
        response['private_job_settings'] = res?.data?.data?.private_job_settings || {};
        response['weekly_work_time_enabled'] = res?.data?.data?.weekly_work_time_enabled || false;
        response['employment_type_enabled'] = res?.data?.data?.employment_type_enabled || false;
        response['apprenticeship_type'] = res?.data?.data?.apprenticeship_type || {};
        if (jobId) {
            let jobSettingsUrl = `brands/${brandId}/jobs/${jobId}/settings`;
            let res = await BrandApi_1.request(jobSettingsUrl, 'GET');
            if (res?.data?.status_code !== 200) {
                throw (res.data);
            }
            response['job_hiring_settings'] = res?.data?.data;
            return response;
        }
        else {
            return response;
        }
    }
    ;
    static async downloadApplicantsCvs(brandId, payload) {
        let response = await BrandApi_1.request(`brands/${brandId}/applications/resumes/download`, 'POST', payload);
        if (response.data.status_code !== 200) {
            throw (response.data);
        }
        return response.data.data;
    }
    ;
    static async getUserBrandsList(limit, afterPaginationBrandId, searchTerm, loadLocations, loadMedia, includeArchived) {
        let apiEndpoint = environmentsConfig.get("coreReaderAPIServers" /* ENDPOINT.CORE_READER */);
        let url = `${apiEndpoint}users/brand/search`;
        let payload = {
            limit: limit || 200,
            include_archived: includeArchived,
        };
        if (afterPaginationBrandId) {
            payload['after_pagination_brand_id'] = afterPaginationBrandId;
        }
        if (searchTerm) {
            payload['search_term'] = searchTerm;
        }
        if (loadLocations !== undefined) {
            payload['load_locations'] = loadLocations;
        }
        if (loadMedia !== undefined) {
            payload['load_media'] = loadMedia;
        }
        let response = await BrandApi_1.request(url, 'POST', payload);
        return response.data.data.brands;
    }
    static async getBrandMedia(brandId, payload) {
        const response = await BrandApi_1.request(`brands/${brandId}/media`, 'GET', payload);
        if (response?.data.data) {
            return response.data.data.media;
        }
        else {
            throw response;
        }
    }
    static async getUserAssignedJobs(payload) {
        let apiEndpoint = environmentsConfig.get("coreReaderAPIServers" /* ENDPOINT.CORE_READER */);
        let url = `${apiEndpoint}users/jobs/search`;
        let response = await BrandApi_1.request(url, 'POST', payload);
        return response.data.data;
    }
    static async deleteJobsAssignees(payload) {
        let response = await BrandApi_1.request(`brands/jobs/assignees`, "DELETE", payload);
        return response.data.data;
    }
    static async getPresignedUrlForFileExtension(brandId, fileExtension) {
        const queryParams = {
            file_extension: fileExtension,
        };
        const response = await BrandApi_1.request(`brands/${brandId}/notification_templates/presigned_url`, "GET", queryParams);
        return response.data.data;
    }
    static async getTalentPoolJobs(brandId) {
        const response = await BrandApi_1.request(`brands/${brandId}/talent-pool/jobs`, "GET");
        if (response?.data?.data && response.status === 200) {
            return response.data.data;
        }
        throw response;
    }
    static async getManagers(brandId, payload) {
        const response = await BrandApi_1.request(`brands/${brandId}/employers/search`, 'POST', payload);
        if (response?.status === 200 && response?.data?.data) {
            return response.data.data;
        }
        throw response;
    }
    ;
    static async updateTalentPoolJob(brandId, jobId, jobData) {
        const response = await BrandApi_1.request(`brands/${brandId}/talent-pool/jobs/${jobId}`, "PUT", jobData);
        if (response?.data?.data && response.status === 200) {
            return response.data.data;
        }
        throw response;
    }
    static async createTalentPoolJob(brandId, jobData) {
        const response = await BrandApi_1.request(`brands/${brandId}/talent-pool/jobs`, "POST", jobData);
        if (response?.data?.data && response.status === 200) {
            return response.data.data.id;
        }
        throw response;
    }
    static async getCSPPreSignedUrlForFileExtension(brandId, fileExtension, fileName) {
        const queryParams = {
            file_extension: fileExtension,
            file_name: fileName
        };
        const response = await BrandApi_1.request(`brands/${brandId}/career_story_pages/presigned_url`, "GET", queryParams);
        if (response.data.status_code !== 200) {
            throw (response.data);
        }
        return response.data.data;
    }
    static async getCSPSocialLinks(brandId) {
        const response = await BrandApi_1.request(`brands/${brandId}/career_story_pages/social_links`, "GET");
        if (response.data.status_code !== 200) {
            throw (response.data);
        }
        return response.data.data;
    }
    static async getCSPs(brandId) {
        const response = await BrandApi_1.request(`brands/${brandId}/career_story_pages`, "GET");
        if (response.data.status_code !== 200) {
            throw (response.data);
        }
        return response.data.data;
    }
    static async getCSPDetails(brandId, CSPId) {
        const response = await BrandApi_1.request(`brands/${brandId}/career_story_pages/${CSPId}`, "GET");
        if (response.data.status_code !== 200) {
            throw (response.data);
        }
        return response.data.data;
    }
    static async createCSP(brandId, payload) {
        const response = await BrandApi_1.request(`brands/${brandId}/career_story_pages`, 'PUT', payload);
        if (response.data.status_code !== 200) {
            throw (response.data);
        }
        return response.data.data.id;
    }
    ;
    static async getCareerStoryPageSettings(brandId) {
        const response = await BrandApi_1.request(`brands/${brandId}/career_story_pages/settings`, "GET");
        if (response.data.status_code !== 200) {
            throw (response.data);
        }
        return response.data.data;
    }
    ;
    static async createCareerStoryPageForPreview(brandId, data) {
        let payload = {
            content: data
        };
        const response = await BrandApi_1.request(`brands/${brandId}/career_story_pages/preview_content`, "POST", payload);
        if (response.data.status_code !== 200) {
            throw (response.data);
        }
        return response.data.data;
    }
    ;
    static async getExternalBrandsSettings(businessId, params) {
        let response = await BrandApi_1.request(`teamlive/employees/businesses/${businessId}/brands`, "GET", params);
        if (response.data?.data && response.status === 200) {
            return response.data.data.brands;
        }
        throw (response);
    }
    ;
};
BrandApi = BrandApi_1 = __decorate([
    harriApi({ teamlive: "APIServers" /* ENDPOINT.CORE */, harri: "APIServers" /* ENDPOINT.CORE */ })
], BrandApi);
export { BrandApi };
//# sourceMappingURL=brand.api.js.map